import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import createDragSortMixin from '@xunlei/thunder-ui-vue/lib/mixins/drag-mixin/index.js';

var NAMESPACE = 'td';

var CustomTitle = {
  functional: true,
  render: function render(h, ctx) {
    var parent = ctx.parent;
    return parent.type === 'normal' ? h(
      'div',
      { 'class': 'td-browser-tab__text' },
      [typeof parent.renderTitle === 'function' ? parent.renderTitle.call(parent._renderProxy, h, {
        title: parent.title,
        pinned: parent.pinned
      }, parent.index) : parent.$slots.default || parent.title]
    ) : '';
  }
};

var BrowserTabItem = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', _vm._g(_vm._b({ staticClass: "td-browser-tab__item", class: _vm.mergeClass, style: { 'min-width': _vm.pinned ? _vm.$parent.pinnedMinWidth + 'px' : 'unset' }, attrs: { "title": _vm.title, "data-item-index": _vm.index, "data-current": _vm.current }, on: { "mouseenter": function mouseenter($event) {
          return _vm.handleMouseEvent(true);
        }, "mouseleave": function mouseleave($event) {
          return _vm.handleMouseEvent(false);
        }, "mousedown": _vm.handleClick } }, 'div', _vm.type === 'normal' ? _vm.tabAttrs(_vm.tab, _vm.index) : {}, false), _vm.type === 'normal' ? _vm.tabListeners(_vm.tab, _vm.index) : {}), [_c('custom-title'), _vm._v(" "), _vm.type === 'normal' && !_vm.pinned || _vm.tab && _vm.tab.closable ? _c('a', { staticClass: "td-browser-tab__close", attrs: { "href": "javascript:;", "title": "关闭" }, on: { "mousedown": function mousedown($event) {
          $event.stopPropagation();
        }, "click": function click($event) {
          $event.stopPropagation();return _vm.handleRemove($event);
        } } }, [_c('i', { staticClass: "td-icon td-icon-close" })]) : _vm._e()], 1);
  }, staticRenderFns: [],
  name: NAMESPACE + '-browser-tab-item',

  components: {
    CustomTitle: CustomTitle
  },

  props: {
    tab: Object,
    tabAttrs: Function,
    tabListeners: Function,
    title: {
      type: String,
      default: '新标签页'
    },
    type: {
      type: String,
      default: 'normal'
    },
    current: Boolean,
    first: Boolean,
    pinned: Boolean,
    index: Number,
    renderTitle: Function
  },

  computed: {
    tabAttrsObject: function tabAttrsObject() {
      if (typeof this.tabAttrs === 'function') {
        return this.tabAttrs(this.tab, this.index);
      }
      return {};
    },
    mergeClass: function mergeClass() {
      var mergeClass = {};
      if (this.tabAttrsObject.class) {
        mergeClass = _defineProperty({}, this.tabAttrsObject.class, true);
      }
      return _Object$assign({
        'td-browser-tab__item--first': this.first,
        'td-browser-tab__item--normal': this.type === 'normal',
        'td-browser-tab__item--new': this.type === 'new',
        'is-current': this.current,
        'is-pinned': this.pinned,
        'is-hover': this.isHover
      }, mergeClass);
    }
  },

  data: function data() {
    return {
      isHover: false
    };
  },


  methods: {
    handleRemove: function handleRemove() {
      this.$emit('remove');
    },
    handleMouseEvent: function handleMouseEvent(isHover) {
      this.isHover = isHover;
    },
    handleClick: function handleClick(e) {
      if (e.which === 2) {
        this.$parent.$emit('middle-click', {
          tab: this.tab,
          index: this.index,
          e: e
        });
      }
    }
  }
};

var BrowserTab = {
  name: NAMESPACE + '-browser-tab',

  components: {
    BrowserTabItem: BrowserTabItem
  },

  mixins: [createDragSortMixin({
    container: function container() {
      return this.$refs.groupCon;
    },
    getList: function getList() {
      return this.showableTabs;
    },
    onUpdateList: function onUpdateList() {
      var _this = this;

      var showableTabs = this.showableTabs,
          unpinnedTabs = this.unpinnedTabs,
          pinnedTabs = this.pinnedTabs,
          showableStart = this.showableStart,
          showableEnd = this.showableEnd;

      var tabs = [].concat(_toConsumableArray(pinnedTabs), _toConsumableArray(unpinnedTabs.slice(0, showableStart)), _toConsumableArray(showableTabs), _toConsumableArray(unpinnedTabs.slice(showableEnd + 1, unpinnedTabs.length + 1)));
      this.$emit('update:tabs', tabs);
      this.$emit('update:current', tabs.findIndex(function (tab) {
        return tab.key === _this.currentKey;
      }));
    }
  })],

  props: {
    // simple 简单形状（xl11）， parall 平行四边形（xlx）
    tabStyle: {
      type: String,
      default: 'parall'
    },
    // 异性tab间 重叠部分宽度
    TabOverlapWidth: {
      type: Number,
      default: 20
    },
    // browser-tab 背景色
    background: {
      type: String,
      default: '#bbb'
    },

    // browser tabs
    tabs: Array,

    tabAttrs: {
      type: Function,
      default: function _default() {
        return {};
      }
    },

    tabListeners: {
      type: Function,
      default: function _default() {
        return {};
      }
    },

    current: {
      type: Number,
      default: 0
    },
    renderTitle: Function,
    sortable: Boolean,
    // 不固定tabs的最小宽度
    minWidth: {
      type: Number,
      default: 100
    },
    // 固定tab的最小宽度
    pinnedMinWidth: {
      type: Number,
      default: 220
    },
    // 不固定tab的初始宽度
    unpinnedWidth: {
      type: Number,
      default: 327
    },
    triggerChangeTabByMouseDown: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    // 固定宽度的tabs
    pinnedTabs: function pinnedTabs() {
      return this.tabs.filter(function (tab) {
        return tab.pinned;
      });
    },

    // 不固定宽度的tabs
    unpinnedTabs: function unpinnedTabs() {
      return this.tabs.filter(function (tab) {
        return !tab.pinned;
      });
    },
    groupStyle: function groupStyle() {
      var unpinnedTabsWidth = this.unpinnedTabs.length * this.unpinnedWidth; // 不固定宽度tabs的总宽度
      var pinnedTabLength = this.pinnedTabs.length;
      var pinnedTabOverWith = this.tabStyle === 'simple' ? '0px' : (pinnedTabLength - 1) * this.TabOverlapWidth + 'px';
      var spaceWidth = this.tabStyle === 'simple' ? '0px' : '90px'; // 90px 是右侧新增按钮及padding的宽度, xl11上废弃这个间距

      if (pinnedTabLength === 0) {
        unpinnedTabsWidth += 10;
      }
      var maxWidth = 'calc(100% - ' + spaceWidth + ' - ' + this.pinnedMinWidth + 'px * ' + pinnedTabLength + ' - ' + pinnedTabOverWith + ')';

      return {
        width: unpinnedTabsWidth + 'px',
        maxWidth: maxWidth,
        flexBasis: 'auto',
        position: 'relative'
      };
    }
  },

  data: function data() {
    return {
      moving: false,
      currentKey: null,
      showableTabs: [] // 展示的不固定宽度的tabs
    };
  },


  watch: {
    current: {
      handler: function handler(v) {
        this.currentKey = this.tabs[v].key;
      }
    }
  },

  created: function created() {
    var _this2 = this;

    this.$watch(function () {
      // 需要在unpinnedTabs长度和current变化时执行相同回调，
      // 为了避免执行两次，所以使用函数形式
      // 返回值+l是为了不让eslint报错
      var l = _this2.unpinnedTabs.length + _this2.current;
      return Math.random() + l;
    }, this.handleShowableTabs);
  },


  methods: {
    handleShowableTabs: function handleShowableTabs() {
      var unpinnedTabs = this.unpinnedTabs,
          showableTabs = this.showableTabs,
          pinnedTabs = this.pinnedTabs;

      if (!this.$refs.groupCon) {
        // td-browser-tab-group
        return;
      }
      var areaWidth = this.$refs.groupCon.offsetWidth;
      var length = Math.min(Math.max(Math.floor(areaWidth / this.minWidth), 1), unpinnedTabs.length); // 能展示出的不固定tabs的数量
      var tabs = showableTabs;

      // remove items which does not exist
      var index = 0;
      while (index < tabs.length) {
        if (unpinnedTabs.indexOf(tabs[index]) === -1) {
          tabs.splice(index, 1);
        } else {
          index++;
        }
      }

      if (!tabs || !tabs.length || unpinnedTabs.length === length) {
        tabs = this.showableTabs = unpinnedTabs.slice(0, length);
      }

      if (tabs.length > length) {
        // remove overflow items
        this.removeOverflowItems(length);
        return;
      }

      if (this.current <= pinnedTabs.length - 1) {
        // 当前tab是固定宽度tab
        this.completeShowable(length);
      } else {
        // 当前tab是非固定宽度tab
        var start = unpinnedTabs.findIndex(function (tab) {
          return tab.key === tabs[0].key;
        });
        var end = unpinnedTabs.findIndex(function (tab) {
          return tab.key === tabs[tabs.length - 1].key;
        });
        var current = this.current - pinnedTabs.length;
        if (current < start) {
          var _start = Math.max(current - 2, 0);
          var _end = Math.min(_start + length - 1, _start + tabs.length - 1);
          this.showableTabs = unpinnedTabs.slice(_start, _end + 1);
        } else if (current > end) {
          var _end2 = Math.min(current + 2, unpinnedTabs.length - 1);
          var _start2 = Math.max(0, _end2 - length + 1);
          this.showableTabs = unpinnedTabs.slice(_start2, _end2 + 1);
        } else if (current >= start && current <= end && tabs.findIndex(function (tab) {
          return tab.key === unpinnedTabs[current].key;
        }) === -1) {
          if (Math.abs(current - start) > Math.abs(current - end)) {
            var _end3 = Math.min(current + 2, unpinnedTabs.length - 1);
            var _start3 = Math.max(0, _end3 - length + 1);
            this.showableTabs = unpinnedTabs.slice(_start3, _end3 + 1);
          } else {
            var _start4 = Math.max(current - 2, 0);
            var _end4 = Math.min(_start4 + length - 1, _start4 + tabs.length - 1);
            this.showableTabs = unpinnedTabs.slice(_start4, _end4 + 1);
          }
        } else {
          this.completeShowable(length);
        }
      }
      this.computeStartAndEndIndex();
    },
    computeStartAndEndIndex: function computeStartAndEndIndex() {
      var _this3 = this;

      if (this.showableTabs && this.showableTabs.length) {
        this.showableStart = this.unpinnedTabs.findIndex(function (tab) {
          return tab.key === _this3.showableTabs[0].key;
        });
        this.showableEnd = this.unpinnedTabs.findIndex(function (tab) {
          return tab.key === _this3.showableTabs[_this3.showableTabs.length - 1].key;
        });
      } else {
        this.showableEnd = this.showableStart = 0;
      }
    },

    // 保留当前tab情况下，删除溢出tab
    removeOverflowItems: function removeOverflowItems(length) {
      var _this4 = this;

      var tabs = this.showableTabs;
      var _length = tabs.length - length;
      var current = tabs.findIndex(function (tab) {
        return tab.key === _this4.currentKey;
      });
      if (_length) {
        for (var i = 0; i < _length; i++) {
          if (i < current) {
            tabs.shift();
            length--;
          } else {
            break;
          }
        }
      }
      _length = tabs.length - length;
      if (_length) {
        for (var _i = 0; _i < _length; _i++) {
          tabs.pop();
        }
      }
    },
    completeShowable: function completeShowable(length) {
      var unpinnedTabs = this.unpinnedTabs,
          showableTabs = this.showableTabs;

      var tabs = showableTabs;
      var start = unpinnedTabs.findIndex(function (tab) {
        return tab.key === tabs[0].key;
      });
      var end = unpinnedTabs.findIndex(function (tab) {
        return tab.key === tabs[tabs.length - 1].key;
      });
      var _length = length - tabs.length;
      if (_length) {
        var j = start - 1;
        for (var i = 0; i < _length; i++) {
          if (j > -1) {
            tabs.unshift(unpinnedTabs[j]);
            j--;
          } else {
            break;
          }
        }
      }
      _length = length - tabs.length;
      if (_length) {
        var _j = end + 1;
        for (var _i2 = 0; _i2 < _length; _i2++) {
          if (_j < unpinnedTabs.length) {
            tabs.push(unpinnedTabs[_j]);
            _j++;
          } else {
            break;
          }
        }
      }
    },
    handleSelect: function handleSelect(tab, index) {
      var isMouseDownEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.triggerChangeTabByMouseDown === isMouseDownEvent) {
        this.$emit('update:current', index);
        this.$emit('change', {
          tab: tab,
          index: index
        });
      }
    },
    handleAdd: function handleAdd() {
      this.$emit('add');
    },
    handleRemove: function handleRemove(tab, index) {
      this.$emit('remove', {
        tab: tab,
        index: index
      });
    },
    handleTotalClick: function handleTotalClick(e) {
      this.$emit('total-click', e);
    }
  },

  mounted: function mounted() {
    this.handleShowableTabs();
    window.addEventListener('resize', this.handleShowableTabs);
    this.currentKey = this.tabs[this.current].key;
  },
  render: function render() {
    var _this5 = this;

    var h = arguments[0];
    var tabStyle = this.tabStyle,
        background = this.background,
        tabs = this.tabs,
        tabAttrs = this.tabAttrs,
        tabListeners = this.tabListeners,
        pinnedTabs = this.pinnedTabs,
        unpinnedTabs = this.unpinnedTabs,
        showableTabs = this.showableTabs,
        renderTitle = this.renderTitle,
        $scopedSlots = this.$scopedSlots,
        current = this.current,
        groupStyle = this.groupStyle,
        moveIndexs = this.moveIndexs,
        moving = this.moving;

    return h(
      'div',
      { 'class': { 'td-browser-tab': true, 'td-browser-tab--simple': tabStyle === 'simple' }, style: { background: background } },
      [pinnedTabs.map(function (tab) {
        var index = tabs.indexOf(tab);
        return h(
          BrowserTabItem,
          _mergeJSXProps([{ props: tab }, {
            attrs: {
              current: index === current,
              first: index === 0,
              index: index,
              'render-title': renderTitle,
              tab: tab,
              tabAttrs: tabAttrs,
              tabListeners: tabListeners
            },
            on: {
              'remove': function remove() {
                return _this5.handleRemove(tab, index);
              }
            },
            nativeOn: {
              'click': function click() {
                return _this5.handleSelect(tab, index);
              },
              'mousedown': function mousedown() {
                return _this5.handleSelect(tab, index, true);
              }
            }
          }]),
          [$scopedSlots.default ? $scopedSlots.default({ tab: tab, index: index }) : '']
        );
      }), h(
        'div',
        {
          'class': 'td-browser-tab-group',
          style: groupStyle,
          ref: 'groupCon'
        },
        [showableTabs.map(function (tab, selfIndex) {
          var index = tabs.indexOf(tab);
          return h(
            BrowserTabItem,
            _mergeJSXProps([{ props: tab }, {
              attrs: {
                current: index === current,
                first: index === 0,
                index: index,

                'data-index': selfIndex,
                'data-key': tab.key,
                'render-title': renderTitle,

                tab: tab,
                tabAttrs: tabAttrs,
                tabListeners: tabListeners
              },
              ref: 'item' + selfIndex, nativeOn: {
                'click': function click() {
                  return _this5.handleSelect(tab, index);
                },
                'mousedown': function mousedown() {
                  return _this5.handleSelect(tab, index, true);
                }
              },
              on: {
                'remove': function remove() {
                  return _this5.handleRemove(tab, index);
                }
              },

              'class': {
                'is-transition': !moveIndexs || moveIndexs[0] !== selfIndex,
                'is-hidden': moving && moveIndexs && moveIndexs[0] === selfIndex
              },
              key: tab.key }]),
            [$scopedSlots.default ? $scopedSlots.default({ tab: tab, index: index }) : '']
          );
        })]
      ), h(BrowserTabItem, {
        attrs: { title: '\u6253\u5F00\u65B0\u6807\u7B7E\u9875', type: 'new' },
        nativeOn: {
          'click': this.handleAdd
        },
        style: { visibility: moving ? 'hidden' : 'visible' } }), showableTabs.length < unpinnedTabs.length ? h(
        'div',
        { 'class': 'td-browser-tab__item td-browser-tab__item--more', on: {
            'click': this.handleTotalClick
          }
        },
        [h(
          'span',
          { 'class': 'td-browser-tab__number-more' },
          [unpinnedTabs.length]
        )]
      ) : '']
    );
  }
};

BrowserTab.install = function (Vue) {
  Vue.component(BrowserTab.name, BrowserTab);
};

export default BrowserTab;
